module.exports = __webpack_public_path__ + "img/8.fca972d0.png";